import { useEffect, useState } from "react";
import logo from "../../../../logo.png";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Who We Serve", href: "#audience" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 cursor-pointer group">
          <img src={logo} alt="Association Integrity logo" className="h-10 w-auto object-contain flex-shrink-0" />
          <span className="flex flex-col leading-tight">
            <span
              className={`font-heading text-lg font-semibold tracking-tight ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              Association Integrity
            </span>
            <span
              className={`text-[11px] uppercase tracking-[0.18em] ${
                scrolled ? "text-foreground-500" : "text-background-50/80"
              }`}
            >
              South Florida Compliance
            </span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-50/90 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+19544444747"
            className={`text-sm font-medium flex items-center gap-2 cursor-pointer whitespace-nowrap ${
              scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-50/90 hover:text-background-50"
            }`}
          >
            <i className="ri-phone-line" />
            <span className="font-bold">(954) 444-4747</span>
          </a>
          <a
            href="#contact"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Compliance Audit
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`ri-${open ? "close" : "menu"}-line text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-3">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block text-foreground-800 font-medium py-2 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="block text-center bg-primary-500 text-background-50 font-semibold px-5 py-3 rounded-md cursor-pointer whitespace-nowrap"
          >
            Free Compliance Audit
          </a>
        </div>
      )}
    </header>
  );
}